import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import page_45router_45global from "/app/src/middleware/page-router.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  page_45router_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/src/middleware/auth.ts")
}